
import fetchApi from "../fetch-api";
import { getQueryPath } from "ui-io/get-query-path";
import { FundingTrendsIO } from "../funding-io";
import { MarketCapT } from "../common-io";

type ParamsPropsT = {
  year?: number;
  date?: string;
	marketCapital?: MarketCapT;
};

export const getFundingTrends = (props: ParamsPropsT) => {
  let params = props;
  const queryPath = getQueryPath({...params});
  return {
    queryKey: ["FUNDING_TRENDS", queryPath],
    queryFn: () =>
      fetchApi({
        service:"core-service",
        headers:{method: 'GET'},
        pathname: `/funding-trends?${ queryPath}`,
        codec: FundingTrendsIO,
      })
  };
};
